var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader-container"},[_c('v-progress-circular',{staticClass:"tabloader",attrs:{"indeterminate":"","color":"blue","width":"2","size":"38"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }